import { Component } from '@angular/core';
import { NavController, MenuController } from 'ionic-angular';
import { ToastController } from 'ionic-angular';

import { HomePage } from '../home/home';

// ---- COMMON MODULES ---- //
import { Functions } from '../../providers/functions';
import { TranslateService } from '@ngx-translate/core';
import { UserdataModel } from '../../providers/userdata-model';
import { GameModel } from '../../providers/game-model';
import { GamerulesModel } from '../../providers/gamerules-model';
import { DataExchanger } from '../../providers/data-exchanger';
import { LoadingController } from 'ionic-angular';
import { ModalController } from 'ionic-angular';
import { PlayPage } from '../play/play';
import { Auth } from '../../providers/auth';

@Component({
  selector: 'page-versuspvpsync',
  templateUrl: 'versuspvpsync.html',
  host: { '(window:resize)': 'handleResizeEvents($event)' }
})
export class VersusPVPsyncPage {
  language: string;

  loadingText: string; //Text for loading pop
  pvp_sync_modal_title: string; //Text for loading modal
  pvp_sync_modal_title_finded: string; //Text for loading modal finded
  pvp_sync_modal_disconnect: string; //Text for loading modal
  userInfo: Object; //obj with current user info
  
  room: string = ""; //Room name
  connected: boolean = false; //Check connection
  socket; //= io.connect('http://xtribe.eu:'+this.functions.socketPort[this.functions.developMode]);
  vsPlayerName: string; //Show the vs player name
  vsPlayerGuid: string; //Show the vs player guid
  localPlayerName: string; //Show the local player name
  localPlayerGuid: string; //Show the loca player guid
  pvpLoadingCheck: boolean = true; //Show loading or vs image

  refreshIntervalId
  settingsChanged: boolean;
  constructor(public rubedoSideMenu: MenuController, public modalCtrl: ModalController, public auth: Auth, public loadingCtrl: LoadingController, public functions: Functions, public toastCtrl: ToastController, public translate: TranslateService, public navCtrl: NavController, public gamesrulesModel: GamerulesModel, public userdataModel: UserdataModel, public dataExchanger: DataExchanger, public playModel: GameModel) {
    this.rubedoSideMenu = rubedoSideMenu;
    this.rubedoSideMenu.enable(this.functions.sidemenuEnabled, 'rubedoSideMenu');
    this.functions.setSideMenuColorEnabled(true);
    this.language = '';
    this.socket = this.functions.getSocket();

    this.translate.get('lodingPvPSync').subscribe(res => {
      this.loadingText = res;
    });
    this.translate.get('pvp_sync_modal_title').subscribe(res => {
      this.pvp_sync_modal_title = res;
    });
    this.translate.get('pvp_sync_modal_title_finded').subscribe(res => {
      this.pvp_sync_modal_title_finded = res;
    });
    this.translate.get('pvp_sync_modal_disconnect').subscribe(res => {
      this.pvp_sync_modal_disconnect = res;
    });
 
    this.userInfo = {
      guidUser: this.userdataModel.getGuidUser(),
      username: this.userdataModel.getUsername()
    }

    //Socket fix for avoid the 2 seconds set interval update on db
    var that = this;
    this.socket.on('PvpAsyncDataStored', function (data) { 
     // console.log(data)
     console.log("In PvpAsyncDataStored Socket return")
     var waitUpdate = setInterval(function () {
      clearInterval(waitUpdate);
      that.dataExchanger.getVersusPVPSyncGames().then((response) => {
        console.log("PvpAsyncDataStored UPDATED");
      });
      }
      , 2500);
    })

    this.socket.on('PvpAsyncDataUpdated', function (data) { 
      // console.log(data)
      console.log("In PvpAsyncDataUpdated Socket return")
      var waitUpdate = setInterval(function () {
       clearInterval(waitUpdate);
       that.dataExchanger.getVersusPVPSyncGames().then((response) => {
         console.log("PvpAsyncDataUpdated UPDATED");
       });
       }
       , 2500);
     })
  }

  ionViewWillEnter() {
    //before the page in question becomes active
    this.functions.changeShowSidemenuButtonTo(this.functions.sidemenuEnabled);
    this.functions.getLanguage();
    this.settingsChanged = false;

    this.dataExchanger.getVersusPVPSyncGames().then((response) => {
      //console.log(response);
    });
  }

  ionViewWillLeave() {
    //before the page leaves the viewport
    this.functions.setLanguage();
    if (this.settingsChanged) {
      this.dataExchanger.storeUserGamedataOnServer(true);
      console.log("Setting changed... saving on server");
    }
    this.settingsChanged = false;
    clearInterval(this.refreshIntervalId);

    
  }

  goToMainMenu() {
    this.navCtrl.setRoot(HomePage, {});
  }

  startPVPSync() {
    var that = this;
    this.socket.on('connect', function (data) { 
      that.connected = true;
      console.log('@ Connected To Socket')
    });

    clearInterval(this.refreshIntervalId);
    this.findPlayer();

  }

  //Pop up for check game result
  rewardPVPSync(singleGameData) {
    if (singleGameData.win == "win_versus" || singleGameData.win == "lost_versus" || singleGameData.win == "win_versus_for_disconnection") {
      this.dataExchanger.addOutGameBonusPointToScoreAndAdjustLevel(this.functions.bonusScorePVP[singleGameData.win + "PVPSync"]);
    }

    singleGameData.rewarded = this.functions.currentTimestamp();
    this.dataExchanger.setDataGameStatusVersusPVPAsync(singleGameData.idGame, singleGameData.guidUser, "rewarded").then((response) => { });

    var pointsGained = singleGameData.scoreFinal - singleGameData.scoreInitial;
    var message='';
    switch (singleGameData.win) {
      case "win_versus": {
        if (this.functions.language == 'it') {
          message="<h1><strong>HAI VINTO!</h1></strong>Hai guadagnato " + pointsGained + " punti e " + this.functions.bonusScorePVP[singleGameData.win + "PVPSync"] + " punti bonus!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continua a giocare da casa su xtribe.eu/rubedo!";
          }
        }
        if (this.functions.language == 'en') {
          message="<h1><strong>YOU WIN!</h1></strong>You gained " + pointsGained + " points e " + this.functions.bonusScorePVP[singleGameData.win + "PVPSync"] + " bonus points!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continue playing at home at xtribe.eu/rubedo!";
          }
        }
        this.functions.showWalkthroughWithMessage(message, "superhappy");
        break;
      }
      case "lost_versus": {
        if (this.functions.language == 'it') {
          message="<h1><strong>HAI PERSO!</h1></strong>Giocando, hai comunque guadagnato " + pointsGained + " punti!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continua a giocare da casa su xtribe.eu/rubedo!";
          }
        }
        if (this.functions.language == 'en') {
          message="<h1><strong>YOU LOST!</h1></strong>By playing, you gained " + pointsGained + " points, anyway!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continue playing at home at xtribe.eu/rubedo!";
          }
        }
        this.functions.showWalkthroughWithMessage(message, "supersad");
        break;
      }
      case "win_versus_for_disconnection": {
        if (this.functions.language == 'it') {
          message="<h1><strong>HAI VINTO!</h1></strong>Hai guadagnato " + pointsGained + " punti e " + this.functions.bonusScorePVP[singleGameData.win + "PVPSync"] + " punti bonus!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continua a giocare da casa su xtribe.eu/rubedo!";
          }
        }
        if (this.functions.language == 'en') {
          message="<h1><strong>YOU WIN!</h1></strong>You gained " + pointsGained + " points e " + this.functions.bonusScorePVP[singleGameData.win + "PVPSync"] + " bonus points!";
          if (this.auth.barbicanEventActive) {
            message=message+" Continue playing at home at xtribe.eu/rubedo!";
          }
        }
        this.functions.showWalkthroughWithMessage(message, "superhappy");
        break;
      }
    }

  }



  getChunkForPVPgame() {
    return new Promise((resolve) => {
      this.dataExchanger.getChunkForPVPgame(this.userdataModel.getGuidUser(), this.functions.getGuidChallengerPvpSync(), this.functions.getIdBookChosenVersusPVPSync()).then((response) => {
        resolve(response);
      });
    });
  }

  findPlayer() {
    console.log("@ Finding Player")

    //Set myusername and myguid in popup pvp workaraund

    document.getElementById('localPlayerName').innerHTML = this.userdataModel.getUsername();
    //document.getElementById('localPlayerGuid').innerHTML = "("+this.userdataModel.getGuidUser()+")";

    var that = this;
    this.socket.emit('play', that.userInfo);
    //When a player leave the game or game ended 
    this.socket.on('game end', function (data) {
      that.room = ''; //Empty room var
    });
    document.getElementById("find-pvp-player-pop").style.display = "block";
  }
}



// WEBPACK FOOTER //
// ./src/pages/versuspvpsync/versuspvpsync.ts